import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

import LanguageSwitcher from '../ui/LanguageSwitcher';
import { useLanguage } from '../../contexts/LanguageContext';
import logo from '../../assets/images/logo.png';
import './Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const { t } = useLanguage();
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);

    const navItems = [
        { label: t('nav.home'), path: '/' },
        { label: t('nav.about'), path: '/about' },
        { label: t('nav.departments'), path: '/departments' },
        { label: t('nav.contact'), path: '/contact' },
    ];

    return (
        <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
            <div className="header__container">
                <Link to="/" className="header__logo">
                    <div className="header__logo-icon">
                        <img src={logo} alt="Da Vinci Institute" />
                    </div>
                </Link>

                <nav className={`header__nav ${mobileMenuOpen ? 'header__nav--active' : ''}`}>
                    <ul className="header__nav-list">
                        {navItems.map((item) => (
                            <li key={item.path} className="header__nav-item">
                                <Link
                                    to={item.path}
                                    className={`header__nav-link ${location.pathname === item.path ? 'header__nav-link--active' : ''}`}
                                    aria-current={location.pathname === item.path ? 'page' : undefined}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="header__actions">
                    <LanguageSwitcher />
                    <div className="header__socials">
                        <a href="https://www.facebook.com/davinciinst" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
                        <a href="https://www.instagram.com/davinci_institute/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                        <a href="https://www.linkedin.com/company/da-vinci-institute/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
                    </div>
                    <Link to="/contact" className="header__cta-button">
                        {t('hero.contact')}
                    </Link>
                    <button
                        className={`header__mobile-toggle ${mobileMenuOpen ? 'header__mobile-toggle--active' : ''}`}
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
